import { h, Component } from "preact";

import Collapsible from "./Collapsible";

class AdminPane extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
  }

  toggle(pane) {
    this.setState({
      openPane: pane
    });
  }

  render({ adminLinks = [] }, { openPane }) {
    const sections = adminLinks.reduce((acc, current) => {
      if (!acc[current.section]) {
        acc[current.section] = [];
      }
      acc[current.section].push({ url: current.url, label: current.label });

      return acc;
    }, {});

    return (
      <div>
        <div class="user-widget__mega_menu__admin--title">Administration</div>
        <div class="user-widget__mega_menu__admin__list">
          {Object.keys(sections)
            .sort()
            .map(section => (
              <Collapsible title={section} onClick={() => this.toggle(section)} open={openPane === section}>
                <ul>
                  {sections[section].sort((a, b) => a.label > b.label).map(l => (
                    <li>
                      <a
                        href={l.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {l.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </Collapsible>
            ))}
        </div>
      </div>
    );
  }
}

export default AdminPane;



// WEBPACK FOOTER //
// ./src/AdminPane.js